/*
  MISÜ - Wishlist (2026-10-22), portage de la wishlist BBP (bbdp-wishlist.js) sur le thème Horizon.
  Favoris gardés dans le navigateur (localStorage, clé misu_wishlist_v1), sans compte client
  et sans serveur. Chargé en différé par snippets/misu-wishlist-head.liquid.
  - Cartes produits : le bouton cœur est rendu côté serveur (snippets/misu-card-extras.liquid),
    ce script ne fait que synchroniser son état.
  - Fiche produit : le cœur est ajouté à droite du titre (h1 de .product-details).
  - En-tête : lien cœur + compteur rendu par snippets/misu-wishlist-header-link.liquid.
  - Page /pages/wishlist : liste construite ici (sections/misu-wishlist-page.liquid).
  - Klaviyo « Added to Wishlist » uniquement si le consentement marketing Shopify est donné.
*/
(function () {
  'use strict';
  if (window.MisuWishlist) return;

  var KEY = 'misu_wishlist_v1';
  var MAX = 100;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var HEART_PATH = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  var cfg = window.MisuWishlistConfig || {};
  var S = cfg.strings || {};
  var root = String(cfg.root || '/');
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var memory = [];
  var cache = {};

  function t(key, fallback) {
    return S[key] || fallback;
  }

  /* ---------- Stockage ---------- */

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (i) {
        return i && typeof i.h === 'string' && i.h;
      });
    } catch (e) {
      return memory.slice();
    }
  }

  function write(list) {
    memory = list.slice(0, MAX);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(memory));
    } catch (e) {
      /* stockage indisponible : la liste vit le temps de la page */
    }
  }

  function has(handle) {
    return read().some(function (i) {
      return i.h === handle;
    });
  }

  function add(handle, id) {
    var list = read().filter(function (i) {
      return i.h !== handle;
    });
    list.unshift({ h: handle, id: id || null, t: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(
      read().filter(function (i) {
        return i.h !== handle;
      })
    );
  }

  /* ---------- Boutons ---------- */

  function heartIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', HEART_PATH);
    svg.appendChild(path);
    return svg;
  }

  function setButton(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? t('remove', 'Retirer des favoris') : t('add', 'Ajouter aux favoris'));
  }

  function makeButton(handle, id, source, on) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'misu-wish-btn';
    btn.setAttribute('data-handle', handle);
    if (id) btn.setAttribute('data-id', id);
    btn.setAttribute('data-source', source);
    btn.appendChild(heartIcon());
    setButton(btn, on);
    return btn;
  }

  function sync() {
    var list = read();
    var set = {};
    list.forEach(function (i) {
      set[i.h] = true;
    });
    var buttons = document.querySelectorAll('.misu-wish-btn[data-handle]');
    for (var b = 0; b < buttons.length; b++) {
      var on = !!set[buttons[b].getAttribute('data-handle')];
      if (buttons[b].getAttribute('aria-pressed') !== (on ? 'true' : 'false')) setButton(buttons[b], on);
    }
    var link = document.getElementById('misu-wish-link');
    if (link) {
      var bubble = link.querySelector('.misu-wish-count');
      var text = link.querySelector('.misu-wish-count__text');
      if (bubble && text) {
        var label = list.length > 99 ? '99+' : String(list.length);
        if (text.textContent !== label) text.textContent = label;
        bubble.hidden = list.length === 0;
      }
    }
    prunePage(set, list.length);
  }

  /* ---------- Fiche produit : cœur à droite du titre ---------- */

  function mountProduct() {
    if (!cfg.product || !cfg.product.handle) return;
    var main = document.getElementById('MainContent') || document;
    if (main.querySelector('.misu-wish-btn--pdp')) return;
    var h1 = main.querySelector('.product-details h1') || main.querySelector('h1');
    if (!h1 || !h1.parentNode) return;
    var holder = h1.parentNode;
    var btn = makeButton(cfg.product.handle, cfg.product.id, 'product', has(cfg.product.handle));
    btn.className += ' misu-wish-btn--pdp';
    holder.classList.add('misu-pdp-title');
    holder.appendChild(btn);
  }

  /* ---------- Données produit et Klaviyo ---------- */

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error('product ' + response.status);
        return response.json();
      });
      cache[handle].catch(function () {
        delete cache[handle];
      });
    }
    return cache[handle];
  }

  function imageUrl(src, width) {
    var url = String(src || '');
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function marketingConsent(callback) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.marketingAllowed === 'function') {
      callback(!!api.marketingAllowed());
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        var loaded = window.Shopify.customerPrivacy;
        callback(!error && !!loaded && typeof loaded.marketingAllowed === 'function' && !!loaded.marketingAllowed());
      });
      return;
    }
    callback(false);
  }

  /* Envoyé uniquement si le consentement marketing est donné dans la bannière Shopify. */
  function track(handle, source) {
    if (!cfg.klaviyo) return;
    marketingConsent(function (allowed) {
      if (!allowed) return;
      fetchProduct(handle)
        .then(function (p) {
          if (!p) return;
          var props = {
            Name: p.title,
            ProductID: p.id,
            Handle: p.handle,
            URL: window.location.origin + root + 'products/' + p.handle,
            ImageURL: imageUrl(p.featured_image, 600),
            Price: p.price / 100,
            CompareAtPrice: p.compare_at_price ? p.compare_at_price / 100 : null,
            ProductType: p.type || '',
            Available: !!p.available,
            Source: source
          };
          if (window.klaviyo && typeof window.klaviyo.track === 'function') {
            window.klaviyo.track('Added to Wishlist', props);
          } else {
            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Added to Wishlist', props]);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Page Ma wishlist ---------- */

  function group(value, separator) {
    var out = '';
    for (var i = 0; i < value.length; i++) {
      if (i > 0 && (value.length - i) % 3 === 0) out += separator;
      out += value.charAt(i);
    }
    return out;
  }

  function amount(cents, decimals, thousands, decimalMark) {
    var parts = (cents / 100).toFixed(decimals).split('.');
    var text = group(parts[0], thousands);
    return parts.length > 1 ? text + decimalMark + parts[1] : text;
  }

  function money(cents) {
    var format = String(cfg.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    var start = format.indexOf('{{');
    var end = format.indexOf('}}');
    if (start < 0 || end < start) return amount(cents, 2, '.', ',');
    var key = format.slice(start + 2, end).trim();
    var value;
    if (key === 'amount_no_decimals') value = amount(cents, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') value = amount(cents, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') value = amount(cents, 0, '.', ',');
    else if (key === 'amount_with_space_separator') value = amount(cents, 2, ' ', ',');
    else if (key === 'amount_no_decimals_with_space_separator') value = amount(cents, 0, ' ', ',');
    else if (key === 'amount_with_apostrophe_separator') value = amount(cents, 2, '’', '.');
    else value = amount(cents, 2, ',', '.');
    return format.slice(0, start) + value + format.slice(end + 2);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  /* Ajout au panier : Shopify.actions (API standard utilisée par Horizon, met à jour le tiroir panier),
     sinon /cart/add.js puis la page panier. */
  function addToCart(variantId, btn, msg) {
    btn.disabled = true;
    msg.textContent = '';
    var done = function () {
      btn.disabled = false;
    };
    var fail = function (text) {
      msg.textContent = text || t('error', 'Une erreur est survenue. Réessaie.');
      done();
    };
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      var call;
      try {
        call = actions.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: 1 }] });
      } catch (e) {
        call = null;
      }
      if (call && typeof call.then === 'function') {
        call
          .then(function (result) {
            if (result && result.userErrors && result.userErrors.length) {
              fail(result.userErrors[0].message);
              return;
            }
            msg.textContent = t('added', 'Ajouté au panier');
            done();
            try {
              if (typeof actions.openCart === 'function') actions.openCart();
            } catch (e) {}
          })
          .catch(function () {
            fail();
          });
        return;
      }
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          fail(result.json.description || result.json.message);
          return;
        }
        msg.textContent = t('added', 'Ajouté au panier');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        fail();
      });
  }

  /* Libellé d'une variante : seulement les options qui varient (la pointure pour MISÜ 01). */
  function variantLabel(p, variant) {
    var options = p.options || [];
    var values = variant.options || [];
    var parts = [];
    for (var i = 0; i < values.length; i++) {
      var opt = options[i];
      if (opt && opt.values && opt.values.length > 1) parts.push(values[i]);
    }
    return parts.length ? parts.join(' / ') : variant.title;
  }

  function buildItem(p) {
    var url = root + 'products/' + p.handle;
    var li = el('li', 'misu-wl-item');
    li.setAttribute('data-handle', p.handle);

    var media = el('a', 'misu-wl-item__media');
    media.href = url;
    media.setAttribute('tabindex', '-1');
    media.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imageUrl(p.featured_image, 600);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 600;
      img.height = 600;
      media.appendChild(img);
    }
    li.appendChild(media);
    var wish = makeButton(p.handle, p.id, 'wishlist', true);
    wish.className += ' misu-wish-btn--on-image';
    li.appendChild(wish);
    if (!p.available) li.appendChild(el('span', 'misu-badge misu-badge--soldout misu-wl-item__badge', t('soldout', 'Épuisé')));

    var head = el('div', 'misu-wl-item__head');
    var title = el('a', 'misu-wl-item__title', p.title);
    title.href = url;
    head.appendChild(title);
    var price = el('div', 'misu-wl-item__price');
    if (p.compare_at_price && p.compare_at_price > p.price) price.appendChild(el('s', '', money(p.compare_at_price)));
    price.appendChild(el('span', '', money(p.price)));
    head.appendChild(price);
    li.appendChild(head);

    var actions = el('div', 'misu-wl-item__actions');
    var msg = el('p', 'misu-wl-item__msg');
    msg.setAttribute('role', 'status');
    var variants = p.variants || [];

    if (p.available && variants.length) {
      var select = null;
      if (variants.length > 1) {
        select = el('select', 'misu-wl-item__select');
        select.setAttribute('aria-label', t('size', 'Pointure'));
        var placeholder = el('option', '', t('size', 'Pointure'));
        placeholder.value = '';
        placeholder.selected = true;
        select.appendChild(placeholder);
        variants.forEach(function (variant) {
          var label = variantLabel(p, variant);
          var option = el('option', '', variant.available ? label : label + ' — ' + t('soldout', 'Épuisé'));
          option.value = variant.id;
          if (!variant.available) option.disabled = true;
          select.appendChild(option);
        });
        actions.appendChild(select);
      }
      var addBtn = el('button', 'button misu-wl-item__add', t('add_to_cart', 'Ajouter au panier'));
      addBtn.type = 'button';
      addBtn.addEventListener('click', function () {
        var variantId = select ? select.value : variants[0].id;
        if (!variantId) {
          msg.textContent = t('choose', 'Choisis ta pointure');
          if (select) select.focus();
          return;
        }
        addToCart(variantId, addBtn, msg);
      });
      actions.appendChild(addBtn);
    } else {
      var view = el('a', 'button button-secondary misu-wl-item__add', t('view', 'Voir le produit'));
      view.href = url;
      actions.appendChild(view);
    }
    actions.appendChild(msg);
    li.appendChild(actions);
    return li;
  }

  function pageParts() {
    var page = document.getElementById('misu-wishlist-page');
    if (!page) return null;
    return {
      page: page,
      list: page.querySelector('[data-list]'),
      empty: page.querySelector('[data-empty]'),
      note: page.querySelector('[data-note]')
    };
  }

  function prunePage(set, count) {
    var parts = pageParts();
    if (!parts || !parts.list) return;
    var rows = parts.list.querySelectorAll('.misu-wl-item');
    for (var r = 0; r < rows.length; r++) {
      if (!set[rows[r].getAttribute('data-handle')]) parts.list.removeChild(rows[r]);
    }
    if (parts.empty && parts.page.getAttribute('data-rendered') === 'true') parts.empty.hidden = count > 0;
  }

  function renderPage() {
    var parts = pageParts();
    if (!parts || !parts.list) return;
    var items = read();
    if (!items.length) {
      parts.page.setAttribute('data-rendered', 'true');
      if (parts.empty) parts.empty.hidden = false;
      return;
    }
    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.h).then(
          function (product) {
            return { item: item, product: product };
          },
          function () {
            return { item: item, product: undefined };
          }
        );
      })
    ).then(function (results) {
      var gone = 0;
      parts.list.textContent = '';
      results.forEach(function (result) {
        if (result.product === null) {
          gone++;
          remove(result.item.h);
          return;
        }
        if (!result.product) return;
        parts.list.appendChild(buildItem(result.product));
      });
      if (gone && parts.note) {
        parts.note.textContent = gone === 1 ? t('gone_one', 'Un article n’est plus disponible et a été retiré de ta liste.') : t('gone_many', 'Des articles ne sont plus disponibles et ont été retirés de ta liste.');
        parts.note.hidden = false;
      }
      parts.page.setAttribute('data-rendered', 'true');
      sync();
    });
  }

  /* ---------- Événements ---------- */

  /* Phase de capture : passe avant le clic de la carte produit Horizon (qui ouvrirait la fiche). */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var btn = target && target.closest ? target.closest('.misu-wish-btn[data-handle]') : null;
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = btn.getAttribute('data-handle');
      if (has(handle)) {
        remove(handle);
      } else {
        add(handle, btn.getAttribute('data-id'));
        track(handle, btn.getAttribute('data-source') || 'card');
      }
      sync();
    },
    true
  );

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });

  function init() {
    mountProduct();
    sync();
    renderPage();
    if (window.MutationObserver && document.body) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          mountProduct();
          sync();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.MisuWishlist = { list: read, has: has, add: add, remove: remove, refresh: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
